module.exports = __webpack_public_path__ + "static/media/599.7554(30).41b9213b.pdf";